import React from "react";
import "./RefundPolicy.css";


const RefundPolicy = () => {
  return (
    <div className="Refund">
    <div className="container mx-auto p-6 max-w-3xl text-gray-800 text-center">
      <h1 className="text-3xl font-bold text-blue-700">Refund & Cancellation Policy</h1>
      <p className="mt-4 text-lg">
      Effective Date: 02 / 08 / 2024 <br></br>
      <p className="mt-4 text-lg">
Thank you for choosing to engage with Smaaash. Our Refund and Cancellation Policy is designed to ensure clarity and transparency, in compliance with the Consumer Protection Act, 2019. Please review the following Policy carefully.
</p>
​
<h2 className="text-2xl text-center font-semibold mt-6 text-gray-900">1. No-Refund Policy for Tournaments
</h2>
      <p className="mt-2">

​

1.1 Transparency and Acceptance

By registering for our tournament, you acknowledge and agree that all entry fees and related payments are non-refundable. This policy is clearly communicated during the registration process to ensure that all participants are fully informed before committing.

​

1.2 Operational Costs

Your entry fee covers various operational costs of the tournament, including venue, staffing, technology, and prize pools. Once these costs are incurred, they are non-recoverable, which necessitates our no-refund policy.

​​

1.3 Fairness and Prize Pool Integrity

The prize pool's integrity relies on the total number of participants. Issuing refunds would reduce the prize pool, potentially disadvantaging other competitors. Therefore, no refunds will be issued, except in the specific cases outlined below.

​

1.4 Exceptions for Unforeseen Circumstances

While we maintain a strict no-refund policy, we recognize the following exceptions:

Event Cancellation or Significant Alteration: If the tournament is canceled or significantly altered due to reasons within our control, registered participants will be eligible for a full refund or alternative compensation, as mutually agreed upon.

Service Not As Described: If the tournament does not meet the description provided at the time of registration, participants may request a refund. This request will be processed in accordance with the Consumer Protection Act, 2019.

​​

1.5 Force Majeure

In the event of cancellation due to unforeseen circumstances beyond our control (such as natural disasters, government restrictions, or other force majeure events), refunds will not be provided. However, we will strive to offer alternative solutions, such as rescheduling the event.

​

1.6 Dispute Resolution

For any concerns or disputes regarding this policy or the tournament, please contact our support team as mentioned below. We are committed to addressing your issues fairly and promptly, in line with the Consumer Protection Act, 2019.
</p>
​
<h2 className="text-2xl text-center font-semibold mt-6 text-gray-900">2. Refund and Cancellation Policy for Other Services or Products​
</h2>
      <p className="mt-2">

2.1 Cancellation Request

For bookings or orders related to services or products other than tournaments, you may request a cancellation within 48 hours of the booking or ordering.

​

2.2 Refund Processing

Refunds for cancellations of other services or products will be processed within 7-10 working days. The timing of the refund may vary based on your payment method and processing times.

​

2.3 Contact Information

To request a cancellation or for any queries related to refunds, please contact us at:

Email: support@smaaash-entertainment.in 

Grievance Officer: Nilesh Kapile grievanceofficer@smaaash-entertainment.in 

Contact Number: +91 8657731179 

Corporate Office Address: Metro Avenue G-2, Ground Floor Andheri-Kurla Road Next to WEH Metro Station Andheri (East), Mumbai - 400093​

​

By engaging with our services, you agree to the terms of this Refund and Cancellation Policy. We appreciate your understanding and cooperation.
</p>
</p>
    </div>
    </div>
  );
};

export default RefundPolicy;